/**
 * @param {string} str
 */
export default function upperFirst(str) {
  if (typeof str !== 'string') {
    str = String(str);
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/upperFirst.js
// module id = 62
// module chunks = 1